import { render, staticRenderFns } from "./BtnNext.vue?vue&type=template&id=3475d9c6&scoped=true&"
import script from "./BtnNext.vue?vue&type=script&lang=js&"
export * from "./BtnNext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475d9c6",
  null
  
)

export default component.exports